import { API_PATH } from '../../config';

const locations = fetch(`${API_PATH}/locations`, {
  method: 'POST',
})
    .then((result) => result && result.json && result.json())
    .then((result) => result.locations);

export default () => locations;
